import React, { useState, useEffect } from 'react';
import { Typography, Input } from 'antd';
import crosshairIcon from '../../assets/icons/crosshair.png';
import { ReactComponent as CrosshairPurple } from '../../assets/icons/crosshair_purple.svg';
import BusinessSizeCalculator from '../businessSizeCalculator';
import { Label, Tooltip } from 'components';
import { ReactComponent as Info } from '../../assets/icons/info-icon.svg';
import { ReactComponent as CircleIconCompanySize } from '../../assets/icons/circle_company_size.svg';
import { useSelector } from 'react-redux';
import { getDisplayCompanySizeLabel } from 'utils/helpers';

const { Text } = Typography;

const BusinessSizeField = props => {
  const {
    value,
    onChange,
    disabled,
    placeholder,
    label,
    name,
    size,
    inputAdditionalClass,
    asterisk = true,
    shouldShowLabel = true,
    ...rest
  } = props;

  //console.log('BusinessSizeField asterisk prop:', asterisk);

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [displayValue, setDisplayValue] = useState('');
  const viewMode = useSelector(state => state.forms.carrier.viewMode);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleClose = () => {
    setIsModalVisible(false);
  };

  const handleSave = businessSize => {
    // Set the local display value
    setDisplayValue(businessSize);

    if (onChange) {
      onChange({
        key: name,
        type: 'businessSize',
        event: businessSize,
      });
    }
  };

  const displayText =
    displayValue || (typeof value === 'string' ? value : value?.event || '');

  const linkStyle = {
    color: '#4F2D7F',
    textDecoration: 'underline !important',
    cursor: 'pointer',
    //borderBottom: '1px solid #1890ff',
    display: 'inline-block',
    position: 'relative',
    fontWeight: '500',
  };

  useEffect(() => {
    if (value) {
      // Handle both string and object formats
      if (typeof value === 'string') {
        setDisplayValue(value);
      } else if (value.event) {
        setDisplayValue(value.event);
      }
    }
  }, [value]);

  return (
    <div className={`business-size-field ${disabled ? 'disabled' : ''}`}>
      {shouldShowLabel ? (
        <div style={{ display: 'inline-flex', alignItems: 'center' }}>
          <Label label="Μέγεθος Επιχείρησης" asterisk={asterisk} />
          <Tooltip
            placement="right"
            className="ml-1"
            overlayClassName="size-tooltip"
            title={
              <div className="tooltip-container">
                <div className="card-header">
                 {/* <span className="info-chip" aria-hidden="true"> */}
                    <CircleIconCompanySize/>
                  {/* </span> */}
                  <h3 className="card-title">Το μέγεθος της επιχείρησής σου</h3>
                </div>
                <div className="size-row">
                  <span className="size-title">Πολύ Μικρή Επιχείρηση:</span>
                  <span className="size-text">
                    Λιγότεροι από 10 Εργαζόμενοι και Ετήσιος Κύκλος Εργασιών και/ή Ισολογισμός &lt;= 2.000.000,00€
                  </span>
                </div>

                <div className="size-row">
                  <span className="size-title">Μικρή Επιχείρηση:</span>
                  <span className="size-text">
                    Λιγότεροι από 50 Εργαζόμενοι (ΕΜΕ) και Ετήσιος Κύκλος Εργασιών και/ή
                    Ισολογισμός &lt;= 10.000.000,00€
                  </span>
                </div>

                <div className="size-row">
                  <span className="size-title">Μεσαία Επιχείρηση:</span>
                  <span className="size-text">
                    Λιγότεροι από 250 Εργαζόμενοι (ΕΜΕ) και Ετήσιος Κύκλος Εργασιών
                    &lt;= 50.000.000,00€ και/ή Ετήσιος Ισολογισμός &lt;= 43.000.000,00€
                  </span>
                </div>

                <div className="size-row">
                  <span className="size-title">Μεγάλη Επιχείρηση:</span>
                  <span className="size-text">
                    Περισσότεροι από 250 Εργαζόμενοι (ΕΜΕ) ή Ετήσιος Κύκλος Εργασιών &gt;
                    50.000.000€ και Ετήσιος Ισολογισμός &gt; 43.000.000,00€
                  </span>
                </div>
                
              </div>
            }
          >
            <Info className="infoIconSmallIban" />
          </Tooltip>
        </div>
      ) : undefined}
      {<Input
        value={getDisplayCompanySizeLabel(displayText)}
        placeholder="Εισάγετε Μέγεθος Επιχείρησης"
        disabled={disabled}
        readOnly
        size={size || 'large'}
        className={`ant-input ${inputAdditionalClass || ''}`}
        classNames={'register-business-size-field'}
      />}

      {!viewMode && (
        <>
          <BusinessSizeCalculator
            visible={isModalVisible}
            onClose={handleClose}
            onSave={handleSave}
            initialValues={{
              annualTurnover: '',
              annualBalance: '',
              numberOfEmployees: '',
            }}
          />
          {!disabled && <div
            style={{ display: 'flex', alignItems: 'center', marginTop: '8px' }}
          >
            <CrosshairPurple />
            <span
              id="businessSizeCalc"
              onClick={showModal}
              style={{
                ...linkStyle,
                marginLeft: '5px',
                textDecoration: 'underline !important',
              }}
            >
              <span
                id="businessSizeCalc"
                style={{
                  textDecoration: 'underline !important',
                  borderBottom: '1px solid #4F2D7F',
                }}
              >
                Βρες το μέγεθος της επιχείρησης
              </span>
            </span>
          </div>}
        </>
      )}
    </div>
  );
};

export default BusinessSizeField;
